module.exports = __webpack_public_path__ + "img/RetroPath.e9a2b539.gif";